// eslint-disable-next-line complexity
const TITLES = {
  likes: {
    icon: 'heart',
    nameKey: 'utils.iconMap.likes.name',
  },
  shares: {
    icon: 'share-variant',
    nameKey: 'utils.iconMap.shares.name',
  },
  comments: {
    icon: 'message-text',
    nameKey: 'utils.iconMap.comments.name',
  },
  videoplays: {
    icon: 'play',
    nameKey: 'utils.iconMap.videoplays.name',
  },
  followers: {
    icon: 'account-group',
    nameKey: 'utils.iconMap.followers.name',
  },
};

export function iconMap(iconTitle) {
  const icon = 'frequently-asked-Questions';
  const nameKey = 'utils.iconMap.unknown.name';

  let iconTitleFormatted = iconTitle;
  if (iconTitle) iconTitleFormatted = iconTitle.toLowerCase();

  return TITLES[iconTitleFormatted] || { icon, nameKey };
}
